/* eslint-disable react/destructuring-assignment,react/prop-types, no-underscore-dangle, react/jsx-one-expression-per-line */

import React from 'react';
import { css } from '@emotion/react';
import AuthUserContext from './context';
import { withFirebase } from '../Firebase';

const confirmationStyle=css`margin-top:14px;`
const emailStyle = css`
  padding: 10px;
`;

function needsEmailVerification(authUser) {
  if (authUser) {
    if (!authUser.emailVerified) {
      console.log('needsEmailVerification -- email not verified! :', authUser);
    }
  }
  return authUser && !authUser.emailVerified && authUser.providerData.map((provider) => provider.providerId).includes('password');
}

const withEmailVerification = (Component) => {
  class WithEmailVerification extends React.Component {
    constructor(props) {
      super(props);

      this.state = { isSent: false };
    }

    onSendEmailVerification = () => {
      this.props.firebase.doSendEmailVerification().then(() => this.setState({ isSent: true }));
    };

    render() {
      return (
        <AuthUserContext.Consumer>
          {(authUser) =>
            needsEmailVerification(authUser) ? (
              <div css={[emailStyle]}>
                {this.state.isSent ? (
                  <p>Email confirmation has been sent. Please check your email (Junk/Spam included) for a confirmation. Refresh this page once you confirmed your e-mail.</p>
                ) : (
                  <p>Verify your email: Please check your email (Junk/Spam included) for a confirmation em-mail or click the button to send another confirmation.</p>
                )}

                <button css={[confirmationStyle]} type="button" onClick={this.onSendEmailVerification} disabled={this.state.isSent}>
                  Send confirmation E-Mail
                </button>
              </div>
            ) : (
              <Component {...this.props} />
            )
          }
        </AuthUserContext.Consumer>
      );
    }
  }

  return withFirebase(WithEmailVerification);
};

export default withEmailVerification;
